export const PAYMENT_TYPES = [
  {
    label: 'Credit Card',
    icon: 'credit_card_s',
    selected: true,
    className: 'credit-card',
  },
  { label: 'Zelle', icon: 'zelle', selected: false, className: 'zelle' },
  {
    label: 'Wire Transfer',
    icon: 'wire_transfer',
    selected: false,
    className: 'wire-transfer',
  },
  {
    label: 'Check',
    icon: 'cheque',
    selected: false,
    className: 'cheque',
  },
  {
    label: 'Venmo',
    icon: 'venmo',
    selected: false,
    className: 'venmo',
  },
];

export const FINANCE_MAIL = 'finance@freshprints.com';
export const FINANCE_VENMO_USERNAME = '@Fresh-Prints';
export const CHEQUE_ADDRESS = 'Fresh Prints LLC, P.O. Box 412063, Boston, MA 02241';
export const CHEQUE_MEMO =
  'If you want to pay by check, send it to the address below with the invoice # in the memo.';

export const INVOICE_FIELD_ERROR_MSGS = {
  FULLNAME: 'What’s your full name?',
  AMOUNT: 'How much do you want to pay?',
  CREDIT_CARD: 'What’s your card number?',
  CREDIT_CARD_INCORRECT: 'That’s not a valid card number.',
  EXPIRY_DATE: 'Enter a valid expiration date.',
  CVV: 'Enter a valid CVV.',
  ZIPCODE: 'Enter a valid zip.',
};

export const INVOICE_PAY_ERROR = 'Failed to pay for invoice.';

export const INVOICE_STATUS = {
  PAID: 'Paid',
  UNPAID: 'Unpaid',
  PARTIALLY_PAID: 'Partially Paid',
  OVERDUE: 'Overdue',
};

export const INVOICE_CUSTOM_ITEM_SVG = '/src/assets/svg/custom_item.svg';

export const FREE_SHIP_TYPES = ['standard', 'mto'];
